import { inject, Service } from '@angular/core';
import {environment} from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {GoogleService} from './google-service';
import {Observable} from 'rxjs';
import {Entity} from '../entity/entity';
import {Factor} from '../model/factor';

@Service()
export class ExtendedWarrantyService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);


  private urlBase = environment.serviceUrl;

  public addExtendedWarranty(entity: Entity): Observable<string> {
    const url = this.urlBase + 'extendedWarranty/add';
    const body = JSON.stringify(entity);
    return this.http.post(url, body, {headers: this.getPostHeaders(), responseType: 'text'});

  }

  public getExtendedWarrantyFactors(): Observable<Factor[]> {
    const url = this.urlBase + 'extendedWarranty/factors';
    return this.http.get<Factor[]>(url, {headers: this.getRequestHeaders()});
  }

  private getPostHeaders(): HttpHeaders {
    return this.getRequestHeaders().set('Content-Type', 'application/json');
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

}
